import { HONOR_HALL_DEV_MOCK_PLAYER_NAMES } from './honorHallDevMockPlayerNames';

const MOCK_STRATEGY_NAMES = Object.freeze([
  'Iron Vanguard',
  'Desert Spear',
  'Shadow Circuit',
  'Covenant Bulwark',
  'Frontier Hold',
  'Crimson Tide',
  'Night Watch',
  'Solar Lance',
  'Grave Pact',
  'Steel Horizon',
  'Ember Trail',
  'Frost Line',
  'Silent Accord',
  'Bone Choir',
  'Meridian Push',
  'Hollow Crest',
  'Ash Pilgrim',
  'Thornwall',
  'Volt Runner',
  'Last Garrison',
]);

const MOCK_FACTIONS = Object.freeze([
  'The Iron Alliance',
  'Asrah',
  'League of Shadows',
  'The Covenant',
  'Remnants of Humanity',
  'Exolot Dominion',
  "Ra's Children",
  'The Conspiracy',
  'The Divine Syndicate',
  'The Hollow',
]);

/**
 * Mock Honor Hall battle strategies rows — descending win rate.
 * @returns {Array<{
 *   rank: number,
 *   strategy_id: null,
 *   strategy_name: string,
 *   player_name: string,
 *   player_id: null,
 *   win_rate: number,
 *   faction_name: string,
 *   is_owned: boolean,
 *   is_subscribed: boolean,
 * }>}
 */
export function buildHonorHallBattleStrategiesDevMockRows() {
  return HONOR_HALL_DEV_MOCK_PLAYER_NAMES.map((playerName, index) => ({
    rank: index + 1,
    strategy_id: null,
    strategy_name: MOCK_STRATEGY_NAMES[index],
    player_name: playerName,
    player_id: null,
    win_rate: Math.round((74.3 - index * 1.15) * 10) / 10,
    faction_name: MOCK_FACTIONS[index % MOCK_FACTIONS.length],
    is_owned: false,
    is_subscribed: false,
  }));
}
